import styled from 'styled-components';
import BubbleTale from './BubbleTale';
import { fonts } from '@/theme/fonts';

interface SpeechBubbleProps {
  title: string;
  desc: string;
}
const SpeechBubble = ({ title, desc }: SpeechBubbleProps) => {
  return (
    <BubbleBox>
      <BubbleTitle>{title}</BubbleTitle>
      <BubbleDesc>{desc}</BubbleDesc>
      <BubbleTale />
    </BubbleBox>
  );
};

export default SpeechBubble;

const BubbleBox = styled.div`
  position: relative;
  border-radius: 20px;
  padding: 16px 20px;
  width: calc(188px - 40px);
  min-height: calc(156px - 32px);
  background: #d9d9d9;
`;

const BubbleTitle = styled.div`
  font-family: ${fonts.family.inter};
  font-size: 12px;
  font-weight: ${fonts.weight.bold};
  color: #000000;
  margin-bottom: 27px;
`;

const BubbleDesc = styled.div`
  font-size: 12px;
  color: #000000;
  white-space: pre-wrap;
  word-wrap: break-word;
  text-align: start;
`;
